function App() {
  return (
      // eslint-disable-next-line react/style-prop-object
      <div className="App">
          <h1>Develop push</h1>
          <h3>Testing luis 1</h3>
          <h3>Testing luis 2</h3>
      </div>
  );
}

export default App;

